import { AnalyticsProvider } from "../../contracts/analytics/analytics";
import { LoggerContract } from "../../contracts/logger/logger";
import Event from "../../core/consts/analytics-events";

function niceConsole(...args: any[]) {
  console.log.apply(undefined, ["%c%s", "color:purple", ...args]);
}
const ConsoleAnalyticsProvider: AnalyticsProvider = (
  logger: LoggerContract
) => ({
  setup() {
    niceConsole("Analytics setup");
  },
  reset() {
    niceConsole("Analytics reset");
  },
  track(event: Event, context: any) {
    niceConsole("Analytics track", event, context);
  },
  identify(identifier: any) {
    niceConsole("Analytics identify", identifier);
  },
});

export default ConsoleAnalyticsProvider;
